import { render, staticRenderFns } from "./PageViewRole.vue?vue&type=template&id=df104490"
import script from "./PageViewRole.vue?vue&type=script&lang=js"
export * from "./PageViewRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports